
import v4 from './v4.vue'

import v3_mobile from './v3_mobile.vue'

export default {
  v4,
  v3_mobile
}
